var _excluded = ["children", "menuAnchor", "menuMaxVisible", "menuWidth", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
var StyledWrapper = styled.div.withConfig({
  componentId: "CL__sc-1mvt603-0"
})(["background-color:var(--surface-bkg-color);border-radius:var(--border-radius-medium);box-shadow:var(--box-shadow-dropdown);color:var(--text-color);height:auto;padding:var(--spacing-2) 0;position:absolute;width:", ";", ""], _ref => {
  var {
    $menuWidth
  } = _ref;
  return $menuWidth;
}, _ref2 => {
  var {
    $menuAnchor
  } = _ref2;
  return $menuAnchor === 'left' ? 'left: 0;' : 'right: 0;';
});
var StyledUl = styled.ul.withConfig({
  componentId: "CL__sc-1mvt603-1"
})(["background-color:transparent;list-style:none;margin-bottom:0;max-height:", "px;overflow-y:auto;padding-left:var(--spacing-1);padding-right:var(--spacing-1);scrollbar-width:thin;width:100%;", ";&::-webkit-scrollbar-thumb{background-color:var(--gray-5);border-radius:var(--border-radius-round);}"], _ref3 => {
  var {
    $menuMaxHeight
  } = _ref3;
  return $menuMaxHeight;
}, _ref4 => {
  var {
    $menuItemsTotal,
    $menuMaxVisible
  } = _ref4;
  return $menuItemsTotal > $menuMaxVisible && "&::-webkit-scrollbar { width: var(--spacing-1);}";
});
var DropdownMenu = _ref5 => {
  var {
      children,
      menuAnchor = 'left',
      menuMaxVisible = 7,
      menuWidth = 'auto',
      size = 'medium'
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded);
  var refMenu = useRef(null);
  var refMenuNonHeadingItems = useRef(null);
  var refFocusedItemIndex = useRef(0);
  var refMenuIsFocused = useRef(true);
  var [maxHeight, setMaxHeight] = useState(0);
  var calculateListMaxHeight = () => {
    var _refMenu$current;
    var menuItems = (_refMenu$current = refMenu.current) === null || _refMenu$current === void 0 ? void 0 : _refMenu$current.querySelectorAll('li');
    var headingMenuItemsCount = Array.from(menuItems !== null && menuItems !== void 0 ? menuItems : []).filter(li => li.getAttribute('role') === 'heading').length;
    var maxChildren = menuMaxVisible > 0 ? menuMaxVisible + headingMenuItemsCount : 7 + headingMenuItemsCount;
    var listItemHeights = 0;
    if (menuItems) {
      for (var i = 0; i < maxChildren; i += 1) {
        var _menuItems$i$offsetHe, _menuItems$i;
        listItemHeights += (_menuItems$i$offsetHe = (_menuItems$i = menuItems[i]) === null || _menuItems$i === void 0 ? void 0 : _menuItems$i.offsetHeight) !== null && _menuItems$i$offsetHe !== void 0 ? _menuItems$i$offsetHe : 0;
      }
    }
    setMaxHeight(listItemHeights);
  };

  // moves focus to new list item based on refFocusedItemIndex
  var changeFocus = () => {
    if (refMenuNonHeadingItems.current) {
      Array.from(refMenuNonHeadingItems.current)[refFocusedItemIndex.current].firstChild.focus();
    }
  };

  // whenever a child cta blurs, check if menu as a whole has
  // lost all focus, and update refMenuIsFocused
  var handleBlur = event => {
    var _refMenu$current2;
    event.stopPropagation();
    if (!((_refMenu$current2 = refMenu.current) !== null && _refMenu$current2 !== void 0 && _refMenu$current2.matches(':focus-within'))) {
      refMenuIsFocused.current = false;
    }
  };

  // whenever a child cta focuses, update refMenuIsFocused
  // we need this because the keyboard can still be used while the menu is open
  // but not focused (e.g. you open the menu then shift+tab backward)
  var handleFocus = event => {
    event.stopPropagation();
    refMenuIsFocused.current = true;
  };

  // keyboard
  var handleGlobalKeydown = useCallback(event => {
    var _refMenuNonHeadingIte, _refMenuNonHeadingIte2;
    event.stopPropagation();
    var totalItems = (_refMenuNonHeadingIte = (_refMenuNonHeadingIte2 = refMenuNonHeadingItems.current) === null || _refMenuNonHeadingIte2 === void 0 ? void 0 : _refMenuNonHeadingIte2.length) !== null && _refMenuNonHeadingIte !== void 0 ? _refMenuNonHeadingIte : 0;
    var FOCUSED_BUT_NOT_ON_FIRST_ITEM = totalItems && refFocusedItemIndex.current > 0;
    var FOCUSED_ON_FIRST_ITEM = totalItems && refFocusedItemIndex.current === 0;
    var FOCUSED_BUT_NOT_ON_LAST_ITEM = totalItems && refFocusedItemIndex.current < totalItems - 1;
    var FOCUSED_ON_LAST_ITEM = totalItems && refFocusedItemIndex.current === totalItems - 1;

    // shift + tab while focused in menu - moves focus natively without changeFocus()
    if (event.shiftKey && event.key === 'Tab' && refMenuIsFocused.current === true) {
      if (FOCUSED_BUT_NOT_ON_FIRST_ITEM) {
        refFocusedItemIndex.current -= 1;
      }
    }

    // tab while focused in menu - moves focus natively without changeFocus()
    if (!event.shiftKey && event.key === 'Tab' && refMenuIsFocused.current === true) {
      if (FOCUSED_BUT_NOT_ON_LAST_ITEM) {
        // increase ref
        refFocusedItemIndex.current += 1;
      }
    }

    // arrow up while focused in menu
    if (event.key === 'ArrowUp' && refMenuIsFocused.current === true) {
      event.preventDefault();
      if (FOCUSED_BUT_NOT_ON_FIRST_ITEM) {
        // increase ref
        refFocusedItemIndex.current -= 1;
      } else if (FOCUSED_ON_FIRST_ITEM) {
        // wrap to bottom
        refFocusedItemIndex.current = totalItems - 1;
      }
      changeFocus();
    }

    // arrow down while focused in menu
    if (event.key === 'ArrowDown' && refMenuIsFocused.current === true) {
      event.preventDefault();

      // adjust refFocusedItemIndex
      if (FOCUSED_BUT_NOT_ON_LAST_ITEM) {
        // down
        refFocusedItemIndex.current += 1;
      } else if (FOCUSED_ON_LAST_ITEM) {
        // wrap to top
        refFocusedItemIndex.current = 0;
      }
      changeFocus();
    }
  }, []);
  useEffect(() => {
    if (refMenu.current) {
      refMenuNonHeadingItems.current = refMenu.current.querySelectorAll('li:not([role="heading"]');
      calculateListMaxHeight();
    }
  }, [children, menuMaxVisible]);
  useEffect(() => {
    changeFocus();
    window.addEventListener('keydown', handleGlobalKeydown);
    return () => {
      window.removeEventListener('keydown', handleGlobalKeydown);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    $menuAnchor: menuAnchor,
    $menuWidth: menuWidth,
    $size: size
  }, /*#__PURE__*/React.createElement(StyledUl, _extends({}, props, {
    "aria-labelledby": props['aria-labelledby'],
    $menuItemsTotal: React.Children.count(children),
    $menuMaxHeight: maxHeight,
    $menuMaxVisible: menuMaxVisible,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: refMenu,
    role: "menu"
  }), children));
};
export default DropdownMenu;